export default {
    day: '2023-09-28',
    content: {
        meta: [
            {
                type: 'bugfix',
                text: '41',
            }
        ],
        mining: [
            {
                unlock: 'miningDepthDweller',
                type: 'clarity',
                text: '38',
            }
        ],
        school: [
            {
                type: 'context',
                text: '14',
            },
            {
                type: 'remove',
                text: '15',
            },
            {
                type: 'remove',
                text: '16',
            },
            {
                type: 'new',
                text: '17',
            },
            {
                type: 'remove',
                text: '18',
            },
            {
                type: 'balance',
                text: '19',
                balance: 'buff',
                before: '5/h',
                after: '10/h',
            },
            {
                type: 'remove',
                text: '20',
            },
            {
                type: 'new',
                text: '21',
            },
            {
                type: 'balance',
                text: '22',
                balance: 'buff',
                before: '30s',
                after: '40s',
            },
            {
                type: 'change',
                text: '23',
            },
            {
                type: 'new',
                text: '24',
            },
            {
                type: 'new',
                text: '25',
            },
            {
                type: 'new',
                text: '35',
            },
            {
                type: 'new',
                text: '26',
            },
            {
                type: 'new',
                text: '39',
            },
            {
                type: 'change',
                text: '27',
            },
            {
                type: 'info',
                text: '34',
            },
            {
                type: 'balance',
                text: '28',
                balance: 'nerf',
                before: '5',
                after: '6',
            },
            {
                type: 'bugfix',
                text: '29',
            },
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'change',
                text: '31',
            },
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'balance',
                text: '30',
                balance: 'buff',
                before: '5',
                after: '4',
            },
            {
                type: 'balance',
                text: '32',
                balance: 'buff',
                before: '10% - 100%',
                after: '25% - 100%',
            },
            {
                type: 'balance',
                text: '33',
                balance: 'buff',
                before: '250',
                after: '175',
            },
            {
                unlock: 'schoolHistorySubfeature',
                type: 'change',
                text: '36',
            }
        ],
        card: [
            {
                type: 'clarity',
                text: '37',
            }
        ],
        event: [
            {
                type: 'new',
                text: '40',
            }
        ],
    }
}
